/**
 * @file index.tsx
 *
 * @fileoverview Renders a correct card depending on the type of card is being displayed.
 */
import React from 'react';
import { LpQuoteParagraph, Paragraph } from '~/jobiqo/types/types';
import LpQuote from '~/jobiqo/components/Landingpage/CardsSlider/components/LpQuote';
import HorizontalCard from '~/jobiqo/components/Landingpage/CardsSlider/components/HorizontalCard';

interface CardWrapperProps {
  /**
   * The card paragraph being displayed.
   */
  card: Paragraph;
}
export default function CardWrapper({ card }: CardWrapperProps) {
  switch (card.bundle) {
    case 'lp_quote':
      return <LpQuote card={card as LpQuoteParagraph} />;
    case 'horizontal_card':
      return <HorizontalCard card={card as any} />;
    default:
      return null;
  }
}
